module.exports = __webpack_public_path__ + "static/media/bg-BiblioBoard-Home.cf15652d.png";